import enMenu from '../en-US/menu';

export default {
  ...enMenu,
  'menu.overseas.media-buyer': '広告運用者サービス',
  'menu.staff-accounts': 'スタッフアカウント',
  'menu.more-blocks': 'その他',
  'menu.system.landing-page-management': 'ランディングページ管理',
  'menu.system.doc-category-management': 'ドキュメント分類',
  'menu.system.doc-management': 'ドキュメント管理',
  'menu.system.doc-create': 'ドキュメントを作成',
  'menu.system.doc-edit': 'ドキュメントを編集',
  'menu.system.site-config': 'サイト設定',
  'menu.system.params-config': 'パラメータ設定',
  'menu.system.domain-config': 'ドメイン設定',
  'menu.system.baota-config': 'BaoTa 設定',
  'menu.system.email-template': 'メールテンプレート',
  'menu.system.rental-domain-management': 'レンタル管理',
  'menu.system.cloak-blacklist-management': 'Cloak IP 管理',
  'menu.system.cloak-whitelist-management': 'Cloak ホワイトリスト',
  'menu.system.membership-plans': '会員プラン設定',
  'menu.system.template-library-management': 'テンプレートライブラリ管理',
  'menu.system.wallet-config': 'ウォレット設定',
  'menu.system.recharge-records': 'チャージ履歴',
  'menu.system.agent-management': '代理管理',
  'menu.system.public-review-page-management': '公共審査ページ',
  'menu.ad-callback': '広告コールバック',
  'menu.ad-callback.tiktok-callback': 'TikTok API',
  'menu.ad-callback.tiktok-create': '設定を作成',
  'menu.ad-callback.tiktok-edit': '設定を編集',
  'menu.ad-callback.tiktok-stats': '統計分析',
  'menu.ad-callback.facebook-callback': 'Facebook API',
  'menu.ad-callback.facebook-create': '設定を作成',
  'menu.ad-callback.facebook-edit': '設定を編集',
  'menu.ad-callback.facebook-stats': '統計分析',
  'menu.ad-callback.manual-ad-callback': '手動コールバック',
  'menu.ad-callback.manual-ad-callback-create': '手動コールバックを作成',
  'menu.ad-callback.pinterest-callback': 'Pinterest API',
  'menu.ad-callback.pinterest-create': '設定を作成',
  'menu.ad-callback.pinterest-edit': '設定を編集',
  'menu.ad-callback.pinterest-stats': '統計分析',
  'menu.ad-callback.bigo-callback': 'BigO API',
  'menu.ad-callback.bigo-create': '設定を作成',
  'menu.ad-callback.bigo-edit': '設定を編集',
  'menu.ad-callback.bigo-stats': '統計分析',
  'menu.ad-callback.google-callback': 'Google',
  'menu.ad-callback.google-create': '設定を作成',
  'menu.ad-callback.google-edit': '設定を編集',
  'menu.ad-callback.google-stats': '統計分析',
  'menu.ad-callback.superh-callback': 'スーパーコールバック',
  'menu.ad-callback.superh-create': 'スーパーコールバックを作成',
  'menu.ad-callback.superh-edit': 'スーパーコールバックを編集',
  'menu.ad-callback.deep-callback': 'ディープコールバック',
  'menu.ad-callback.external-callback': '外部コールバック',
  'menu.ad-callback.external-create': '外部コールバックを作成',
  'menu.ad-callback.external-edit': '外部コールバックを編集',
  'menu.ad-callback.external-stats': '外部コールバック統計',
  'menu.overseas': '海外振り分け',
  'menu.overseas.kakao-list': 'KakaoTalk',
  'menu.overseas.whatsapp-list': 'WhatsApp',
  'menu.overseas.whatsapp-stats': 'WhatsApp統計',
  'menu.overseas.line-list': 'Line',
  'menu.overseas.facebook-diversion': 'Facebook',
  'menu.overseas.tg-list': 'Telegram',
  'menu.overseas.sms-list': 'SMS',
  'menu.overseas.custom-diversion': 'カスタム振り分け',
  'menu.overseas.service-management': 'サービス管理',
  'menu.overseas.work-order': '作業オーダー管理',
  'menu.customer-diversion': '高速振り分け',
  'menu.customer-diversion.whatsapp': 'WhatsApp',
  'menu.customer-diversion.line': 'Line',
  'menu.customer-diversion.facebook': 'Facebook',
  'menu.customer-diversion.custom': 'カスタム',
  'menu.customer-diversion.tg': 'Telegram',
  'menu.customer-diversion.service-management': 'サービス管理',
  'menu.customer-diversion.media-buyer': '広告運用者サービス',
  'menu.landing-page': 'ランディングページ',
  'menu.landing-page.page-list': 'ランディングページ一覧',
  'menu.landing-page.ai-landing-page': 'AIランディングページ',
  'menu.landing-page.ai-landing-page-list': 'AIページ一覧',
  'menu.landing-page.ai-landing-page-create': 'AIページ作成',
  'menu.landing-page.ai-landing-page-edit': 'AIページ編集',
  'menu.landing-page.form-management': 'フォーム管理',
  'menu.landing-page.ad-callback-selection': '広告コールバック',
  'menu.landing-page.ad-callback-selection-ios': 'ローカル広告コールバック',
  'menu.landing-page.page-stats': 'アクセス統計',
  'menu.landing-page.template-library': 'テンプレートライブラリ',
  'menu.landing-page.page-create': 'ランディングページを作成',
  'menu.landing-page.page-edit': 'ランディングページを編集',
  'menu.cloak': 'Cloak 管理',
  'menu.chat-management': 'Chat管理',
  'menu.membership': '会員センター',
  'menu.membership.membership-buy': '会員購入',
  'menu.pricing': '料金プラン',
  'menu.docs': 'ドキュメント',
  'menu.doc-detail': 'ドキュメント詳細',
  'menu.bbs': 'フォーラム',
  'menu.user-domain': 'マイドメイン',
  'menu.myShares': '共有管理',
  'menu.myAgent': 'マイ紹介',
  'menu.shareView': '共有を表示',
  'menu.account.center': '個人センター',
  'menu.account.settings': '個人設定',
  'menu.account.logout': 'ログアウト',
};
